import { render } from "./VgtPagination.vue?vue&type=template&id=2ebf1924"
import script from "./VgtPagination.vue?vue&type=script&lang=js"
export * from "./VgtPagination.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__